import { Loader2 } from 'lucide-react';

interface FullScreenLoaderProps {
  message?: string;
}

/**
 * A full-screen loading component using shadcn styling
 *
 * @param message Optional loading message to display
 */
const FullScreenLoader = ({ message = 'Loading...' }: FullScreenLoaderProps) => {
  return (
    <div className='fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex flex-col items-center justify-center'>
      <div className='flex flex-col items-center justify-center gap-4'>
        <Loader2 className='h-12 w-12 animate-spin text-primary' />
        {message && <p className='text-lg font-medium text-muted-foreground'>{message}</p>}
      </div>
    </div>
  );
};

export default FullScreenLoader;
